<!--suppress ALL -->
<script src="jscolor.js"></script>
<form [formGroup]="htmlBlockForm" (ngSubmit)="onSubmit()" class="container mt-4">
  <div formArrayName="htmlBlocks">
    <div *ngFor="let block of htmlBlocks.controls; let i=index" [formGroupName]="i" class="card mb-3">
      <div class="card-body">
        <div class="row" *ngIf="block.value.type == 'products'">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="title-{{block.value.uid}}" translate>Title</label>
              <input formControlName="title" id="title-{{block.value.uid}}" class="form-control" placeholder="{{'Title'| translate}}">
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="title-color-{{block.value.uid}}" translate>Title Color</label>
              <input data-jscolor pattern="^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$" formControlName="titleColor" id="title-color-{{block.value.uid}}" class="form-control" placeholder="{{'Title Color'| translate}}">
            </div>
          </div>
        </div>

        <div class="row">
          <!-- HTML Block -->
          <div class="col-12" *ngIf="block.value.type == 'html' || block.value.type == null || block.value.type == ''">
            <label for="content-{{block.value.uid}}" translate>Content</label>
            <div dir="ltr" style="direction: ltr">
              <div class="ckEditorContent" dir="ltr" style="direction: ltr" [id]="'html_' + block.value.uid">
              </div>
            </div>
            <div *ngIf="submitted && f.content.errors && f.content.errors.required" class="invalid-feedback" translate>Required field</div>
          </div>
          <!-- End of HTML Block -->

          <!-- Product Block -->
          <div class="col-12" *ngIf="block.value.type == 'products'">
            <div class="form-group" dir='rtl'>
              <label for="backgroundColor-{{block.value.uid}}" translate>Products Category</label>
              <input name='rtl-example' class='tagify--rtl-exmaple form-control auto-height' placeholder="{{'Select products categories'| translate}}" [id]="'html_' + block.value.uid">
            </div>
          </div>
          <!-- End of Product Block -->
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="backgroundColor-{{block.value.uid}}" translate>Block Background Color</label>
              <input data-jscolor pattern="^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$" formControlName="backgroundColor" id="backgroundColor-{{block.value.uid}}" class="form-control" placeholder="{{'Block Background Color'| translate}}">
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-danger" (click)="removeHtmlBlock(block.value.uid)">{{'Remove Content' |  translate}}</button>
        &nbsp;&nbsp;
        <button class="btn btn-secondary" (click)="moveUp(block.value.uid)">
          <i class="fa fa-arrow-up" aria-hidden="true"></i>
        </button>
        &nbsp;&nbsp;
        <button class="btn btn-secondary" (click)="moveDown(block.value.uid)">
          <i class="fa fa-arrow-down" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
  <hr>
  <button type="button" class="btn btn-primary" (click)="addHtmlBlock()">{{'Add General Content' |  translate}}</button>&nbsp;&nbsp;
  <button type="button" class="btn btn-primary" (click)="addProductsBlock()">{{'Add Products Block' |  translate}}</button>
</form>
